import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../App/API/api";

export const fetchProjectData = createAsyncThunk(
  "project/fetchData",
  async ({perPage,countryId="all"}, { rejectWithValue }) => {
    try {
      const response = await api.get("/projects",{
        params: {
          perPage: perPage,
          countryId: countryId
        }
      });
      if (response.status === 200) {
        return response.data.data;
      } else {
        return rejectWithValue("Failed to fetch projects");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unknown error occurred"
      );
    }
  }
);

export const projectSlice = createSlice({
  name: "project",
  initialState: {
    loading: false,
    project: null,
    error: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjectData.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(fetchProjectData.fulfilled, (state, action) => {
        state.loading = false;
        state.project = action.payload;
      })
      .addCase(fetchProjectData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default projectSlice.reducer;
